import React, {useState, useEffect} from 'react';
import { Alert } from 'react-bootstrap';

/**
 * Shows remaining requirements of a Password in an Alert. Takes a Password, a Confirm Password, and a password Length
 * @param {*} props
 * @returns JSX Element
 */
export function HHIEPasswordRequirements(props) {
    const [lengthIsGood, setLengthIsGood] = useState(false);
    const [hasUpperCase, setHasUpperCase] = useState(false);
    const [hasLowerCase, setHasLowerCase] = useState(false);
    const [hasNumber, setHasNumber] = useState(false);
    const [hasSpecialChar, setHasSpecialChar] = useState(false);
    const [passwordsMatch, setPasswordsMatch] = useState(false);
    const [hasNonCompliantSC, setHasNonCompliantSC] = useState(false);

    useEffect(() => {
        const pwd = props.password ? props.password : "";
        setLengthIsGood(pwd.length >= props.pwdLength);
        setHasUpperCase(checkForUpperCase(pwd));
        setHasLowerCase(checkForLowerCase(pwd));
        setHasNumber(checkForNumber(pwd));
        setHasSpecialChar(checkForSymbol(pwd));
        setHasNonCompliantSC(checkForNonCompliantSymbol(pwd));
        const conPwd = props.confirmPassword ? props.confirmPassword : "";
        setPasswordsMatch(conPwd === pwd && conPwd !== "");

    }, [props.password, props.confirmPassword]);

    const checkForUpperCase = (word) => hasCharacter(/^[A-Z]+$/, word);
    const checkForLowerCase = (word) => hasCharacter(/^[a-z]+$/, word);
    const checkForNumber    = (word) => hasCharacter(/^[0-9]+$/, word);
    const checkForSymbol = (word) => hasCharacter(/[-!@#$%^&*()_+=/\u0020]/, word);
    const checkForNonCompliantSymbol = (word) => hasCharacter(/[^A-Za-z0-9-!@#$%^&*()_+=/\u0020]/, word);
    // const checkForBadChar   = (word) => !hasCharacter(/[^A-Za-Z0-9-!@#$%^&*()_+=]/)
    const hasCharacter = (regex, word) => {
        let hasCharacter = false;
        if (word.length > 0) {
            for (var i = 0; i<word.length; i++) {
                var letter = word.charAt(i);
                if (letter.match(regex)) {
                    hasCharacter = true;
                    break;
                }
            }
        }
        return hasCharacter;
    };
    

    return (
        (lengthIsGood && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && passwordsMatch && !hasNonCompliantSC) 
        ?
        <Alert variant='info'>
            Valid Password.
        </Alert>
        :
        <Alert variant="warning" style={{ textAlign: 'left' }}>
                Password Requirements
                <ul style={{ fontSize: "12px" }}>
                    {!lengthIsGood && 
                        <li>At least {props.pwdLength} characters long</li>
                    }
                    {!hasUpperCase &&
                        <li>At least 1 uppercase letter</li>
                    }
                    {!hasLowerCase &&
                        <li>At least 1 lowercase letter</li>
                    }
                    {!hasNumber &&
                        <li>At least 1 number</li>
                    }
                    {!hasSpecialChar &&
                        <li>At least 1 special character from !@#$%^&*()-_=+ or space</li>
                    }
                    {hasNonCompliantSC &&
                        <li>Passwords must ONLY have special characters from the following: !@#$%^&*()-_=+ or space</li>    
                    }
                    {!passwordsMatch &&
                        <li>Passwords must match</li>    
                    }
                </ul>
        </Alert>
    )
}